import React from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { useTranslation } from 'react-i18next';

import { getActions } from '../../global';
import './DeleteAccountPage.scss';

const DeleteAccountPage: React.FC = () => {
  const { deleteAccountMagicLinkAction } = getActions();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const removeAccount = async () => {
    const token = searchParams.get('token');
    const username = searchParams.get('username');

    if (token && username) {
      deleteAccountMagicLinkAction({
        hash: token,
      })
    } else {
      navigate('/');
    }
  }

  const goToBack = () => {
    navigate('/'); 
  }

  return (
    <div className='delete-account-wrapper'>
      <div className='delete-account'>
        <button onClick={goToBack} type='button' className='delete-account__close'>X</button>
        <h2 className='delete-account__title'>{t('Settings.confirmTitle')}</h2>
        <div className="delete-account__buttons-wrap">
          <button onClick={goToBack} type='button' className="delete-account__cancled">
            {t('Settings.cancel')}
          </button>
          <button onClick={removeAccount} type='button' className="delete-account__delete">
            {t('Settings.delete')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountPage;
